import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PatientLoader from "../../common/PatientLoader";
import ChatTile from "./ChatTile";
import NoMessage from "./NoMessage";
import StartChat from "./StartChatModal";
import { ReactComponent as SearchIcon } from "../../../assets/icons/Search.svg";
import { ReactComponent as PlusCircleIcon } from "../../../assets/icons/plus-circle.svg";
import { updateMessageInSidebar } from "./AgoraMethods";
import { isEmptyObject } from "jquery";
import { getUnreadMessagesLogic } from "../../../store/features/chat/chatSlice";

const ChatListing = ({
  chatPatients,
  setChatData,
  chatEnabledPatients,
  latestMessage,
  setChatPatients,
}) => {
  const [filterText, setFilterText] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [temp, setTemp] = useState([]);
  const { chatLoading, chatHistory,UnreadPatientsChatCount } = useSelector((state) => state.chat);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!chatLoading && !isEmptyObject(chatHistory)) {
      setTemp(chatHistory?.results);
    }
  }, [chatLoading, chatHistory]);
  useEffect(() => {
    if (isEmptyObject(latestMessage) || chatPatients.length === 0) {
      return;
    }
    updateMessageInSidebar(
      latestMessage?.message,
      latestMessage?.peerID,
      chatPatients,
      setChatPatients,
      latestMessage?.updateBadge
    );
  }, [latestMessage,chatHistory]);

  // useEffect(() => {
  //   setTemp(chatPatients);
  // }, [chatPatients]);

  return (
    <>
      {chatLoading ? (
        <PatientLoader />
      ) : (
        <div
          className="col-sm-12 col-md-6 col-lg-6"
          style={{ borderRight: "2px solid lightgray" }}
        >
          <StartChat
            setIsOpen={setModalOpen}
            modalIsOpen={isModalOpen}
            patientData={chatEnabledPatients}
            setChatData={setChatData}
          />
          <div className="d-flex search-icon-container my-3">
            <SearchIcon style={{ marginTop: "2%" }} />
            <input
              placeholder="Find a chat"
              onInput={(e) => {
                setFilterText(e.target.value);
              }}
              value={filterText}
            />
            <button
              className="btn transparent-btn"
              title="Start a new chat!"
              onClick={() => {
                setModalOpen(true);
              }}
            >
              <PlusCircleIcon fill="#4aa7e0" style={{ marginTop: "2%" }} />
            </button>
          </div>

          {temp && temp?.length > 0 ? (
            <div className="mb-3 chat-list">
              {temp
                .filter((chat) => {
                  if (chat?.name.toLowerCase().includes(filterText)) {
                    if (chat?.rose_chat) {
                      return chat;
                    }
                  }
                  return null;
                })
                .map((chat, index) => {
                  return (
                    <ChatTile
                      key={index}
                      onClick={() => {
                        if (
                          sessionStorage.getItem("openChatID") ===
                          chat?.patient_id.toString()
                        ) {
                          return;
                        }
                        setChatData(chat);
                        dispatch(getUnreadMessagesLogic());
                      }}
                      avatar={chat?.profile_picture}
                      name={chat?.name}
                      // count={chat?.count}
                      count={UnreadPatientsChatCount[chat?.patient_id] || 0}
                      date={chat?.modified}
                      previewText={chat?.latest_message?.replace(/\[.*?\]/g, '').trim()}
                      risk={chat?.flag}
                    />
                  );
                })}
            </div>
          ) : (
            <div className="mb-3 chat-list">
              <NoMessage
                callBack={() => {
                  setModalOpen(true);
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default ChatListing;
